import { classnames } from 'tailwindcss-classnames';
import TcSearchHeading from './_SearchHeading';
import { Th } from 'react-super-responsive-table';
import { useSearchDictionary } from 'components/helpers/AlgoliaSearch/util';
import type { SortFunctionType } from '../types';

interface TcSearchHeadingsProps {
  sortTable: SortFunctionType;
  sortIndicator: {
    columName: string;
    isAscending: boolean;
  };
  txId?: string;
}

const TcSearchHeadings = ({
  sortTable,
  sortIndicator,
  txId,
}: TcSearchHeadingsProps): JSX.Element => {
  const dict = useSearchDictionary();
  const thClass = classnames('p-2.5', 'border', 'border-gray-quartz');
  const diseaseSortCol = txId ? `dt_${txId}` : undefined;
  return (
    <>
      <Th className={thClass}>
        <TcSearchHeading
          label={dict.name}
          sortTable={sortTable}
          showSortIcon
          showToolTip={false}
          sortName="name"
          sortIndicator={sortIndicator}
        />
      </Th>
      <Th className={thClass}>
        <TcSearchHeading
          label={dict.city}
          sortTable={sortTable}
          showSortIcon
          showToolTip={false}
          sortName="city"
          sortIndicator={sortIndicator}
        />
      </Th>
      <Th className={thClass}>
        <TcSearchHeading
          label={dict.state}
          sortTable={sortTable}
          showToolTip={false}
          showSortIcon
          sortName="state"
          sortIndicator={sortIndicator}
        />
      </Th>
      <Th className={thClass}>
        <TcSearchHeading
          label="Total allo transplants"
          sortTable={sortTable}
          showSortIcon
          showToolTip={false}
          sortName="allos"
          sortIndicator={sortIndicator}
          toolTipContent={dict.allosToolTip}
        />
      </Th>
      {diseaseSortCol ? (
        <Th className={thClass}>
          <TcSearchHeading
            label={dict.diseaseTotal}
            sortTable={sortTable}
            showSortIcon
            showToolTip
            sortName={diseaseSortCol}
            sortIndicator={sortIndicator}
            toolTipContent={dict.diseaseTotalTip}
          />
        </Th>
      ) : null}
      <Th className={thClass}>
        <TcSearchHeading
          label={dict.programType}
          sortTable={sortTable}
          showSortIcon
          showToolTip={false}
          sortName="programType"
          sortIndicator={sortIndicator}
        />
      </Th>
      <Th className={thClass}>
        <TcSearchHeading
          label={dict.survivorShip}
          sortTable={sortTable}
          showSortIcon
          showToolTip={false}
          sortName="survivorship"
          sortIndicator={sortIndicator}
        />
      </Th>
    </>
  );
};

export default TcSearchHeadings;
